import { useL10n } from "@ews/react-localization-context";
import SettingsNumberInput from "../../../Settings/SettingsComponents/SettingsNumberInput/SettingsNumberInput";
import { TooltipIcon } from "../../../ToolTip/useTooltip";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import { useModifySystemSpecification, useSystemSpecification } from "../../../ReactData/system";
import SettingsTextInput from "../../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";

const ProtectionScope: React.FC<{ systemId: string; }> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const specification = useSystemSpecification(systemId);
    const modifySystemSpecification = useModifySystemSpecification();

    return <>

        <SettingsCheckbox
            text={t("TRVB_FULL_PROTECTION_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_FULL_PROTECTION_LABEL")} />}
            checked={specification.protectionScope?.fullProtection || false}
            onChange={(checked) =>
            {
                if (specification.protectionScope?.fullProtection === checked) return;
                if (systemId && specification.protectionScope) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        protectionScope: {
                            ...specification.protectionScope,
                            fullProtection: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_COMPARTMENT_PROTECTION_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_COMPARTMENT_PROTECTION_LABEL")} />}
            checked={specification.protectionScope?.fireSectionProtection || false}
            onChange={(checked) =>
            {
                if (specification.protectionScope?.fireSectionProtection === checked) return;
                if (systemId && specification.protectionScope) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        protectionScope: {
                            ...specification.protectionScope,
                            fireSectionProtection: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_EQUIPMENT_PROTECTION_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_EQUIPMENT_PROTECTION_LABEL")} />}
            checked={specification.protectionScope?.equipmentProtection || false}
            onChange={(checked) =>
            {
                if (specification.protectionScope?.equipmentProtection === checked) return;
                if (systemId && specification.protectionScope) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        protectionScope: {
                            ...specification.protectionScope,
                            equipmentProtection: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_CORRIDOR_PROTECTION_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_CORRIDOR_PROTECTION_LABEL")} />}
            checked={specification.protectionScope?.corridorProtection || false}
            onChange={(checked) =>
            {
                if (specification.protectionScope?.corridorProtection === checked) return;
                if (systemId && specification.protectionScope) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        protectionScope: {
                            ...specification.protectionScope,
                            corridorProtection: checked
                        },
                    });
                }
            }} />
        <SettingsCheckbox
            text={t("TRVB_MANUAL_ALARM_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_MANUAL_ALARM_LABEL")} />}
            checked={specification.protectionScope?.manualAlarming || false}
            onChange={(checked) =>
            {
                if (specification.protectionScope?.manualAlarming === checked) return;
                if (systemId && specification.protectionScope) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        protectionScope: {
                            ...specification.protectionScope,
                            manualAlarming: checked
                        },
                    });
                }
            }} />

        <SettingsTextInput
            text={t("TRVB_MONITORINGAREA_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_MONITORINGAREA_LABEL")} />}
            value={specification.protectionScope?.monitoredAreaOfFAS_m2 || ''}
            onBlur={({ value }) =>
            {
                if (specification.protectionScope?.monitoredAreaOfFAS_m2 === value) return;
                if (systemId && specification.protectionScope) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        protectionScope: {
                            ...specification.protectionScope,
                            monitoredAreaOfFAS_m2: value
                        },
                    });
                }
            }
            } />
        <SettingsNumberInput
            text={t("TRVB_NUMBER_OF_FIRE_COMPARTMENTS_LABEL")}
            tooltip={<TooltipIcon text={t("TRVB_NUMBER_OF_FIRE_COMPARTMENTS_LABEL")} />}
            value={specification.protectionScope?.numberOfFireSections || 0}
            onBlur={({ value }) =>
            {
                if (specification.protectionScope?.numberOfFireSections === value) return;
                if (systemId && specification.protectionScope) {

                    modifySystemSpecification(systemId, {
                        ...specification,
                        protectionScope: {
                            ...specification.protectionScope,
                            numberOfFireSections: value
                        },
                    });
                }
            }
            } />
    </>;
};

export default ProtectionScope;
